import type { Patient } from "@louise/patients/patients.types";
import type { HomepageStage } from "./homepage.types";

type FertilityIntentStage = NonNullable<Patient["fertilityIntent"]>["stage"];

export function getStageFromFertilityIntent(
  stage: FertilityIntentStage | null | undefined,
): HomepageStage | null {
  switch (stage) {
    case "trying-naturally":
      return "trying-naturally";
    case "exploring-options":
      return "explore";
    case "getting-ready":
      return "before-treatment";
    case "in-treatment":
      return "in-care";
    default:
      return null;
  }
}
